module.exports = __webpack_public_path__ + "img/screen8.e1174027.png";